import { render, staticRenderFns } from "./thumbnail.vue?vue&type=template&id=5c5fa454&lang=pug&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('5c5fa454', component.options)
    } else {
      api.reload('5c5fa454', component.options)
    }
    module.hot.accept("./thumbnail.vue?vue&type=template&id=5c5fa454&lang=pug&", function () {
      api.rerender('5c5fa454', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Site/thumbnail.vue"
export default component.exports